export default __webpack_public_path__ + "koa.d8216983.png";